import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { stepUp, verifyStep, setStep } from '../../../Redux/Slice/stepSlice';
import { setSelectedProject } from '../../../Redux/Slice/selectedProjectSlice';
import { useDispatch, useSelector } from 'react-redux';
import { API } from '../../../Services/axios';
import { URLS } from '../../../Services/urls';
import SkeletonLoader from '../../../Components/SkeletonLoader';



const HomeItem = () => {
  const [nextPage, setNextPage] = useState(false);
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch()

  const convertText = (text) => {
    if (!text) return text;
    let convertedText = text.replace(/_/g, ' ').toLowerCase();
    convertedText = convertedText.charAt(0).toUpperCase() + convertedText.slice(1);

    return convertedText;
  }

  useEffect(() => {
    setIsLoading(true);
    API.get('/project/')
    .then((resp) => {
      setProjects(resp.data.results)
      console.log("projects:", resp.data.results)
    })
    .catch((error) => {
      console.log("erreur:", error)
    })
    .finally(() => {
      setIsLoading(false);
    })
  }, [])

  const handleClick = (project) => {
    setNextPage(true);
    // navigate('/essence')
    navigate('/' + project.steps[0].name);
    // console.log("steps:", step)
    // console.log("step[0].name:", step[0].name)
    dispatch(setStep(project.steps[0]))
    dispatch(setSelectedProject(project))
    console.log("Projet selectionné:", project)
    console.log("Step du projet selectionné:", project.steps[0])
  }


  return (
    <>
      {isLoading ? (
        // Affichage du skeleton loader pendant le chargement
        Array.from({ length: 4 }, (_, index) => (
          <div key={index} className="col-3" style={{ marginBottom: 24 }}>
            <SkeletonLoader 
              type="project" 
              width="100%" 
              height="280px"
            />
          </div>
        ))
      ) : (
        // Affichage des projets une fois chargés
        projects?.map((project) => (
          <div key={project.id} className="col-3 navigate" style={{ marginBottom: 24, position: "relative", zIndex: 0 }}>
            <Link to={`/projet/${project.id}`}>
              <div  style={{ position: "relative" }}>
                <img
                  src="/assets/images/Solivage-plancher.png"
                  className=""
                  alt="..."
                  style={{ maxWidth: "100%" }}
                />
              </div>
              <div className="rectangle container  pt-3 pb-3" style={{ zIndex: 1, bottom: 0 }}>
                <p className="Card-sub-title lh-1" style={{ zIndex: 2 }}>
                  [Projet]
                </p>
                <p className="Card-title" style={{ opacity: 1, zIndex: 2 }}>
                  {convertText(project.name) || project.name}
                </p>
              </div>
            </Link>
          </div>
        ))
      )}
    </>
  )
}

export default HomeItem